import { registerPlugin } from '@capacitor/core';

export interface WebviewThemePlugin {
  /**
   * iOS only. Pins the native WKWebView scroll/overscroll background (and
   * `underPageBackgroundColor`) to the app theme's `--bg`. Capacitor otherwise
   * defaults the scroll-view background to `UIColor.systemBackground`, which
   * follows the DEVICE's light/dark appearance — so a Light-theme app on a
   * dark-mode phone shows a black band behind the status bar on scroll. No-op /
   * rejects on web + Android (caller swallows the rejection).
   */
  apply(options: { dark: boolean }): Promise<void>;
}

export const WebviewTheme = registerPlugin<WebviewThemePlugin>('WebviewTheme');
